import React, { useEffect, useState } from 'react';
import { Header, Table, Message, Button, Toast, Modal, Icon, Label } from 'react-frontier';
import { Budget, Department } from '../SiteClasses';
import { addCommas, getDepartmentName } from '../SiteUtil';
import { Dropdown } from 'semantic-ui-react';
import classNames from 'classnames';
import API from '../API';

interface ModalProps{
	open: boolean,
	onClose?: ()=>void,
	onComplete: (budgets: number[])=>void,
}

var ApproveBudgetsModal = (props: ModalProps)=>{
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [selectedBudgets, setSelectedBudgets] = useState<number[]>([]);
	var [loading, setLoading] = useState<boolean>(false);
	var [pendingBudgets, setPendingBudgets] = useState<Budget[]>(null);
	var [departmentFilters, setDepartmentFilters] = useState<Department[]>([]);

	useEffect(()=>{
		if(!props.open) return;
		get();
	}, [props.open]);

	useEffect(()=>{
		if(!props.open || pendingBudgets === null) return;
		get();
	}, [departmentFilters]);

	var get = ()=>{
		setPendingBudgets(null);
		API.getBudgets(100, 0, true, departmentFilters).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setPendingBudgets(res.data);
			if(res.data && res.data.length === 1){
				setSelectedBudgets([res.data[0].budget_id]);
			}
		}).catch(err=>{
			setModalPrompts(['Hubo un error cargando los presupuestos pendientes. (ABM-1)']);
			setPendingBudgets([]);
		})
	};

	var approve = ()=>{
	if(selectedBudgets.length === 0 || !pendingBudgets || pendingBudgets.length === 0) return setModalPrompts(['No hay presupuestos seleccionados para aprobar.']);
	
	setLoading(true);
	API.approveBudget(selectedBudgets).then(res=>{
		if(res.error) return setModalPrompts([res.message]);
		Toast.success('Presupuestos aprobados!');
		props.onClose && props.onClose();
		props.onComplete(selectedBudgets);
	}).catch(err=>{
		setModalPrompts(['Hubo un error al aprobar los presupuestos. (ABM-1)']);
	}).finally(()=>{
		setLoading(false);
	});
	};

	return <div>
		<Modal open={props.open} size={pendingBudgets?.length > 1 ? 'large' : 'tiny'} onClose={props.onClose}>
			<Modal.Header>
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					Aprobar presupuestos
					<Dropdown
						text='Filtrar'
						icon='filter'
						labeled
						button
						style={{ color: 'black', fontSize: 14 }}
						className='icon tiny'
					>
						<Dropdown.Menu style={{ right: 0, left: 'auto' }}>
							<Dropdown.Item icon='close' text='Limpiar filtros' onClick={() => setDepartmentFilters([])} />
							<Dropdown.Header content='Departamentos' />
							<Dropdown.Item onClick={() => {
								setDepartmentFilters(prev => 
									prev.includes(Department.OPERACIONES) 
										? prev.filter(d => d !== Department.OPERACIONES)
										: [...prev, Department.OPERACIONES]
								);
							}}>
								<i className={classNames('icon', {
									'check square': departmentFilters.includes(Department.OPERACIONES),
									'square outline': !departmentFilters.includes(Department.OPERACIONES),
								})}></i>
								Operaciones
							</Dropdown.Item>
							<Dropdown.Item onClick={() => {
								setDepartmentFilters(prev => 
									prev.includes(Department.COMERCIAL) 
										? prev.filter(d => d !== Department.COMERCIAL)
										: [...prev, Department.COMERCIAL]
								);
							}}>
								<i className={classNames('icon', {
									'check square': departmentFilters.includes(Department.COMERCIAL),
									'square outline': !departmentFilters.includes(Department.COMERCIAL),
								})}></i>
								Comercial
							</Dropdown.Item>
							<Dropdown.Item onClick={() => {
								setDepartmentFilters(prev => 
									prev.includes(Department.DESARROLLO) 
										? prev.filter(d => d !== Department.DESARROLLO)
										: [...prev, Department.DESARROLLO]
								);
							}}>
								<i className={classNames('icon', {
									'check square': departmentFilters.includes(Department.DESARROLLO),
									'square outline': !departmentFilters.includes(Department.DESARROLLO),
								})}></i>
								Desarrollo
							</Dropdown.Item>
							<Dropdown.Item onClick={() => {
								setDepartmentFilters(prev => 
									prev.includes(Department.RECURSOS_HUMANOS) 
										? prev.filter(d => d !== Department.RECURSOS_HUMANOS)
										: [...prev, Department.RECURSOS_HUMANOS]
								);
							}}>
								<i className={classNames('icon', {
									'check square': departmentFilters.includes(Department.RECURSOS_HUMANOS),
									'square outline': !departmentFilters.includes(Department.RECURSOS_HUMANOS),
								})}></i>
								Recursos Humanos
							</Dropdown.Item>
							<Dropdown.Item onClick={() => {
								setDepartmentFilters(prev => 
									prev.includes(Department.MARKETING) 
										? prev.filter(d => d !== Department.MARKETING)
										: [...prev, Department.MARKETING]
								);
							}}>
								<i className={classNames('icon', {
									'check square': departmentFilters.includes(Department.MARKETING),
									'square outline': !departmentFilters.includes(Department.MARKETING),
								})}></i>
								Marketing
							</Dropdown.Item>
							<Dropdown.Item onClick={() => {
								setDepartmentFilters(prev => 
									prev.includes(Department.CONTABILIDAD) 
										? prev.filter(d => d !== Department.CONTABILIDAD)
										: [...prev, Department.CONTABILIDAD]
								);
							}}>
								<i className={classNames('icon', {
									'check square': departmentFilters.includes(Department.CONTABILIDAD),
									'square outline': !departmentFilters.includes(Department.CONTABILIDAD),
								})}></i>
								Contabilidad
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</Modal.Header>
			{pendingBudgets === null ? (
				<Modal.Content>
					<Header loading text='Cargando presupuestos pendientes...' />
				</Modal.Content>
			) : pendingBudgets.length === 0 ? (
				<Modal.Content>
					<Header text='Sin presupuestos pendientes' subtext='No hay presupuestos pendientes en la selección.' />
					<Message type='warning' centered>
						<div style={{ fontSize: 14 }}>
							Todos los presupuestos seleccionados ya están aprobados o eliminados.
						</div>
					</Message>
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
			) : pendingBudgets.length === 1 ? (
				<Modal.Content>
					<Header text='¿Aprobar presupuesto?' subtext={'Marcará el presupuesto como aprobado'} />
					<Table
						details
						title='Información'
						data={[
							['ID', pendingBudgets[0].budget_id],
							['Título', pendingBudgets[0].budget_title],
							['Evento', pendingBudgets[0].event_name || <Icon name='minus' />],
							['Ciudad', pendingBudgets[0].city || <Icon name='minus' />],
							['Creador', pendingBudgets[0].user_creator_name],
							['Departamento', <><Label style={{ width: 110 }} color='orange'>{getDepartmentName(pendingBudgets[0].department_id)}</Label></> || <Icon name='minus' />],
							['Tipo', pendingBudgets[0].type_name],
							['Monto', '$' + addCommas(pendingBudgets[0].amount)]
						]}
					/>
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
			) : (
				<Modal.Content style={{ maxHeight: 700, overflowY: 'auto', overflowX: 'hidden' }}>
					<div style={{ textAlign: 'center' }}>
						<Button text='Seleccionar todos' color='black' onClick={() => {
						setSelectedBudgets(selectedBudgets.length === pendingBudgets.length ? [] : pendingBudgets.map(b => b.budget_id));
						}}/>
					</div>
					<Table
						selectable
						collapsingIndexes={[0,1, 4, 5, 6, 7]}
						fitted
						style={{ marginTop: 15 }}
						centeredIndexes={[5]}
						onClick={(v: number[]) => {
						var arr = [...selectedBudgets];
						var ix = arr.indexOf(v[1]);
						if(ix === -1) arr.push(v[1]);
						else arr.splice(ix, 1);
						setSelectedBudgets(arr);
						}}
						headers={[
							<div style={{ textAlign: 'center' }}>
								<i className="checkmark icon" style={{ marginRight: 0 }}></i>
							</div>,
							'ID',
							'TÍTULO',
							'Evento',
							'Ciudad',
							'Creador',
							'DEPARTAMENTO',
							'MONTO'
						]}
						data={pendingBudgets.map(b=>{
						var selected = selectedBudgets.indexOf(b.budget_id) !== -1;
							return[
								<i className={classNames('large icon circle', {
									check: selected,
									outline: !selected
								})}></i>,
								b.budget_id,
								b.budget_title,
								b.event_name || <Icon name='minus' />,
								b.city || <Icon name='minus' />,	
								b.user_creator_name,
								b.department_name ? <Label style={{ width: 110 }} color='orange'>{getDepartmentName(b.department_id)}</Label> : <Icon name='minus' />,
								'$' + addCommas(b.amount)
							];
						})}
					/>
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={props.onClose} />
				<Button 
					text='Aprobar' 
					color='black' 
					onClick={approve}
					loading={loading}
				/>
			</Modal.Actions>
		</Modal>
	</div>;
}

export default ApproveBudgetsModal;
